/**
 * FreshnessIndicator — FR-6 / ADR-000 F6: shows the SOURCE's last-data
 * timestamp as delivered by the BFF. Never page-load time; when the source
 * holds no timestamp, the honest absence is shown, not a local clock.
 */

interface FreshnessProps {
  /** Source last-data timestamp, verbatim from the BFF (null when absent). */
  freshness: string | null
  refreshing: boolean
  onRefresh: () => void
}

/** Formats the source timestamp for display without inventing semantics: yyyyMMddHHmmss → readable, other shapes verbatim. */
export function formatFreshness(raw: string): string {
  const compact = /^\d{14}$/.test(raw)
  if (!compact) return raw
  const y = raw.slice(0, 4)
  const mo = raw.slice(4, 6)
  const d = raw.slice(6, 8)
  const h = raw.slice(8, 10)
  const mi = raw.slice(10, 12)
  const s = raw.slice(12, 14)
  return `${y}-${mo}-${d} ${h}:${mi}:${s}`
}

export function FreshnessIndicator({ freshness, refreshing, onRefresh }: FreshnessProps) {
  return (
    <div className="freshness" data-testid="freshness">
      <span className="freshness-label">Source data as of:</span>
      {freshness === null ? (
        <span className="freshness-value freshness-unknown" data-testid="freshness-unknown">
          no data timestamp from source
        </span>
      ) : (
        <span className="freshness-value" data-testid="freshness-value">
          {formatFreshness(freshness)}
        </span>
      )}
      <button type="button" onClick={onRefresh} disabled={refreshing} data-testid="refresh-button" className="refresh-button">
        {refreshing ? 'Refreshing…' : 'Refresh'}
      </button>
    </div>
  )
}
